import { IGetEnv } from '../../interfaces';
import { hostname } from './hostname';

export const getEnv = (): IGetEnv => {
  if (hostname().includes('fabfitfun')) {
    return {
      name: 'prod',
      recurlyPublicKey: 'ewr1-ycpV9efu2sbESBV83SpnqM',
      brainTreePublicKey: 'production_mfvk6md6_ck4srq56sjx2pqns',
      hCaptchaSiteKey: '2fdab357-c1b1-4911-882f-610c4f6676a5',
      getBillingEndpoint: 'https://user.fabfitfun.com/users/self/billing',
      updateBillingEndpoint: 'https://revenue.fabfitfun.com/accounts/self/billing-info',
      localizationEndpoint: 'https://localization-api.fabfitfun.com',
      registerApiEndpoint: 'https://register-api.fabfitfun.com',
      customizeApiEndpoint: 'https://customize-api.fabfitfun.com',
      taxBaseUrl: 'https://tax-api.fabfitfun.com',
      loginUrl: 'https://login.fabfitfun.com',
      baseUrl: 'https://fabfitfun.com',
      couponUrl: 'https://growth-api.fabfitfun.com/coupons/redemption-code/',
    };
  }

  return {
    name: 'dev',
    recurlyPublicKey: 'ewr1-q5BicwbopjVntY6DWMqPqC',
    brainTreePublicKey: 'sandbox_7bt9z7q4_6kjmvscwhbbrw5mm',
    getBillingEndpoint: 'https://user.fff-dev.com/users/self/billing',
    hCaptchaSiteKey: '20000000-ffff-ffff-ffff-000000000002',
    updateBillingEndpoint: 'https://revenue.fff-dev.com/accounts/self/billing-info',
    localizationEndpoint: 'https://localization-api.fff-dev.com',
    registerApiEndpoint: 'https://register-api.fff-dev.com',
    customizeApiEndpoint: 'https://customize-api.fff-dev.com',
    taxBaseUrl: 'https://tax-api.fff-dev.com',
    loginUrl: 'https://login.fff-dev.com',
    baseUrl: 'https://fff-dev.com',
    couponUrl: 'https://growth-api.fff-dev.com/coupons/redemption-code/',
  };
};
